/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';

import AssetModel from './model/AssetModel';
import AssetLocationModel from './model/AssetLocationModel';

import AudioPlayer from '../media/AudioPlayer';

import { lazyload } from 'react-lazyload';

const audioPreview = require('./images/audio.svg');
const stillPreview = require('./images/still.svg');
const videoPreview = require('./images/video.svg');
const unknownPreview = require('./images/unknown.svg');

const findStillAssetPreview = (urls, locationId, width) => {
    if (!urls || urls.length === 0) {
        return null;
    }
    if (locationId) {
        // Find by location id
        const locationUrl = urls.filter(u => u.locationId === locationId);
        if (locationUrl.length > 0) {
            return locationUrl[0].url;
        }
    }
    if (urls.length === 1) {
        // We just have one :)
        return urls[0].url;
    }

    if (width) {
        // Find by most appropriate width
        let largest = urls.filter(u => u.width && u.width >= width);
        if (largest.length > 0) {
            largest = largest.reduce((a, b) => (a.width > b.width ? b : a));

            if (largest) {
                return largest.url;
            }
        }
    }

    return urls[0].url;
};
const findAudioAssetPreview = (urls, locationId) => {
    if (!urls || urls.length === 0) {
        return null;
    }
    if (locationId) {
        // Find by location id
        const locationUrl = urls.filter(u => u.locationId === locationId);
        if (locationUrl.length > 0) {
            return locationUrl[0].url;
        }
        return null;
    }
    if (urls.length === 1) {
        // We just have one :)
        return urls[0].url;
    }

    return urls.reduce((a, b) => (a.length > b.length ? a : b)).url;
};

const mimeType = (asset, location) => {
    const mime = location && location.mimeType ? location.mimeType :
        asset.mimeType ? asset.mimeType : 'audio/mpeg';
    if (mime === 'application/octet-stream') {
        // TODO check for extension
        return 'audio/mp4';
    }
    return mime;
};

@lazyload({
    height: 50,
    offset: 150,
}) @observer
class AssetVisualPreview extends Component {
    render() {
        const {
            asset, location, width, audioPlayer, previewStill, previewAudio,
        } = this.props;
        const widthStyle = { width, height: 'auto' };

        if (!asset && !location && !audioPlayer && !previewAudio) {
            // TODO put a loading image
            return (<img
                className="img-fluid"
                style={widthStyle}
                src={unknownPreview}
                alt="Loading..." />);
        }
        let urls = [];
        if (previewStill && asset && asset.stillPreviews) {
            urls = asset.stillPreviews.peek();
        }
        let audioUrls = [];
        if ((audioPlayer || previewAudio) && asset && asset.type === 'audio' && asset.audioPreviews) {
            // Only if audio
            audioUrls = asset.audioPreviews.peek();
        }

        let audioImagePreviewUrl = audioPreview;

        switch (asset.type) {
        case 'still':
            if (!previewStill) {
                return null;
            }
            if (urls.length > 0) {
                const url = findStillAssetPreview(urls, location ? location.id : null, width);
                return (<img
                    className="img-fluid"
                    style={widthStyle}
                    src={url}
                    alt={`Thumbnail ${asset.title}`} />);
            }
            return (<img
                className="img-fluid"
                style={widthStyle}
                src={stillPreview}
                alt={`Thumbnail ${asset.title}`} />);
        case 'audio':
            if (urls.length > 0) {
                audioImagePreviewUrl = findStillAssetPreview(urls, location ? location.id : null, width) || audioPreview;
            }
            if (audioUrls.length > 0) {
                const audioUrl = findAudioAssetPreview(audioUrls, location ? location.id : null);
                // TODO add audio player integration here
                return (
                    <div>
                        {previewStill ? <img
                            className="img-fluid"
                            style={widthStyle}
                            src={audioImagePreviewUrl}
                            alt={`Thumbnail ${asset.title}`} /> : null}
                        {previewAudio ? <audio controls preload="none" style={{ width: '100%' }}>
                            <source
                                src={audioUrl}
                                type={mimeType(asset, location)} />
                            <track kind="captions" />
                        </audio> : null }
                        {audioPlayer ? <AudioPlayer audioUrl={audioUrl} metadata={asset.metadata} /> : null}
                    </div>);
            }
            return (<img
                className="img-fluid"
                style={widthStyle}
                src={audioImagePreviewUrl}
                alt={`Thumbnail ${asset.title}`} />);
        case 'video':
            if (urls.length > 0) {
                const url = findStillAssetPreview(urls, location ? location.id : null, width);
                return (<img
                    className="img-fluid"
                    style={widthStyle}
                    src={url}
                    alt={`Thumbnail ${asset.title}`} />);
            }
            return (<img
                className="img-fluid"
                style={widthStyle}
                src={videoPreview}
                alt={`Thumbnail ${asset.title}`} />);
        default:
            return (<img
                className="img-fluid"
                style={widthStyle}
                src={unknownPreview}
                alt={`Thumbnail ${asset.title}`} />);
        }
    }
}
AssetVisualPreview.propTypes = {
    asset: PropTypes.instanceOf(AssetModel),
    location: PropTypes.instanceOf(AssetLocationModel),
    width: PropTypes.number,
    previewStill: PropTypes.bool,
    previewAudio: PropTypes.bool,
};
AssetVisualPreview.defaultProps = {
    asset: null,
    location: null,
    width: null,
    previewStill: false,
    previewAudio: false,
};


export default injectIntl(AssetVisualPreview);
